/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 * 
 **/
import { createIcon } from "@v2/helpers/icons/create-icon";
export const ArrowLeftIcon = createIcon({
  displayName: "ArrowLeftIcon",
  viewBox: "0 0 16 16",
  path: (<g fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M9.24989 13.5608L4.92666 9.23755C4.24325 8.55413 4.24325 7.44609 4.92666 6.76268L9.24989 2.43945L10.3105 3.50011L5.98732 7.82334C5.88969 7.92097 5.88969 8.07926 5.98732 8.17689L10.3105 12.5001L9.24989 13.5608Z" fill="currentColor" /></g>)
});